import { generatePath } from 'react-router-dom';

export const makeUrl = <T extends Record<string, any>>(url: string, params: T): string => {
  return Object.entries(params).reduce((acc, [key, value]) => {
    return acc.replace(`{${key}}`, value);
  }, url);
};

interface CompanyRouteParams {
  benchmarkId?: string;
  companyUid?: string;
  dataset?: string;
  dbVersion?: string;
}

export const getPath = (
  pathBenchmark: string,
  pathSearch: string,
  { benchmarkId, companyUid, dataset, dbVersion }: CompanyRouteParams,
): string => {
  if (benchmarkId) {
    return generatePath(pathBenchmark, {
      benchmarkId,
      companyUid,
    });
  }

  if (dataset && dbVersion) {
    return generatePath(pathSearch, {
      dataset,
      dbVersion,
      companyUid,
    });
  }

  return `/database/financial-data/${companyUid}`;
};
